import { ESTADO_LOTE, TONO } from "@/lib/migracion";

export function EstadoLoteBadge({ estado, testid }) {
  const e = ESTADO_LOTE[estado] || { label: estado || "—", tono: "slate" };
  return (
    <span data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${TONO[e.tono]}`}>
      {e.label}
    </span>
  );
}
